import styled from "styled-components";
import Icon from "../../../../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../../../../styles/common/mixins/helpers.styled.js";
import panelErrorMobileThemes from "./themes/index.js";
export const PanelAccommodationMobileError = styled.div.withConfig({
    displayName: "styled__PanelAccommodationMobileError",
    componentId: "sc-d2b219f0-0"
})`
	background-color: ${({ theme  })=>theme.colors.primary.lightest};
	padding: 16px;

	${FlexMixin({})}

	& > span {
		${FontMixin({
    size: 'medium',
    weight: 'medium',
    height: 'base'
})}
		color: ${({ theme  })=>theme.colors.primary.lighter};
	}

	& > ${Icon} {
		color: ${({ theme  })=>theme.colors.primary.lighter};
		${FontMixin({
    size: 'larger',
    weight: 'medium',
    height: 'base'
})}
		margin-right: 8px;
	}

	${({ theme  })=>panelErrorMobileThemes[theme.id]?.PanelError?.()}
`;

//# sourceMappingURL=styled.js.map